import { render, staticRenderFns } from "./AddAffectedComponentModal.vue?vue&type=template&id=010caa23&"
import script from "./AddAffectedComponentModal.vue?vue&type=script&lang=js&"
export * from "./AddAffectedComponentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports